import {Badge, withStyles} from '@material-ui/core';
import './style.scss'

const MyBadge = withStyles((theme) => ({
    badge: {
        right: 5,
        top: 5,
        backgroundColor: "#DE4B7B",
        color: "#444444"
    },
}))(Badge);

export default MyBadge
